import React, { type FC } from 'react'
import { useSelector } from 'react-redux'
import { Tooltip, Button, type ButtonProps } from 'antd'
import { selectNamespace } from '../../state/slices/appSlice'
import { NAMESPACE, PLEASE_SELECT } from '../../components/shared/constants'

interface IButtonWithTooltipProps extends ButtonProps {
  tooltipText?: string
  namespaceDependency?: boolean
}
export const ButtonWithTooltip: FC<IButtonWithTooltipProps> = ({
  tooltipText,
  namespaceDependency = false,
  disabled,
  ...buttonProps
}) => {
  const namespace = useSelector(selectNamespace)

  const mergedDisabled = typeof disabled === 'boolean'
    ? disabled
    : (!namespace && namespaceDependency) || !namespace

  const mergedTooltipText =
    !namespace && namespaceDependency
      ? `${PLEASE_SELECT} ${NAMESPACE}`
      : tooltipText

  return (
    <Tooltip title={mergedTooltipText}>
      <Button
        disabled={mergedDisabled}
        {...buttonProps}
      />
    </Tooltip>
  )
}
